document.addEventListener("DOMContentLoaded", function () {
  const checkoutBtn = document.getElementById("checkout-button");

  if (!checkoutBtn) {
    console.warn("Checkout button not found in DOM.");
    return;
  }

  checkoutBtn.addEventListener("click", function (e) {
    const vatInputEl = document.querySelector(".bss-b2b-vat-input");
    const vatValue = vatInputEl ? vatInputEl.value.trim() : "";

    if (vatValue === "") {
      // Temporarily disable the VAT input so the BSS app doesn't validate it
      if (vatInputEl) {
        vatInputEl.disabled = true;
      }

      // Allow natural form behavior or redirect manually
      // If the button is a form submit, you don't need this redirect
      window.location.href = "/checkout";

      return;
    }

    // If VAT is entered, let the BSS app validate it
  });
});
